module.exports = __webpack_public_path__ + "img/ClearSky.bc575634.png";